<template lang="pug">
div
  el-row.cardList
    el-col(:span="12")
      app-display(
        label="Responsável:",
        :content="responsavel.nome"
        v-if="responsavel.nome"
        :class = "compararResumoGeo && compararResumoGeo.mudouNomeResponsavel ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="CPF do responsável:",
        :content="responsavel.cpf",
        v-if="responsavel.cpf"
        :class = "compararResumoGeo && compararResumoGeo.mudouCpfResponsavel ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="RNP:",
        :content="responsavel.creaRnp",
        v-if="responsavel.creaRnp"
        :class = "compararResumoGeo && compararResumoGeo.mudouCreaRnp ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="Formação:",
        :content="responsavel.formacao",
        v-if="responsavel.formacao"
        :class = "compararResumoGeo && compararResumoGeo.mudouFormacao ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="Código de credenciamento junto ao INCRA:",
        :content="responsavel.codigoIncra"
        v-if="responsavel.codigoIncra"
        :class = "compararResumoGeo && compararResumoGeo.mudouCodigoIncra ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        label="Credenciado:",
        :content="possuiCredenciadoGeo ? 'Sim' : 'Não'"
        v-if="(possuiCredenciadoGeo != null && possuiCredenciadoGeo != '') || isPara"
      )

</template>

<script>
import AppDisplay from '../AppDisplay'

export default {
  props: {
    responsavel: {
      type: Object,
      required: true
    },
    possuiCredenciadoGeo: {
      type: Boolean
    },
    compararResumoGeo: {
      type: Object,
      required: true
    }
  },
  components: {
    AppDisplay
  },
  computed: {
    isPara () {
      return process.env.ESTADO === 'pa'
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin-top {
    margin-top: 10px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {
    .cardList {
      display: flex;
      flex-direction: column;
      width: 470px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesResponsavelGeo.vue